// import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import Modal from "react-bootstrap/Modal";
import { useEffect } from "react";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import { Grid, Input, MenuItem, Select, InputLabel, Typography } from "@mui/material";
import Box from '@mui/material/Box';
import FormControlLabel from "@mui/material/FormControlLabel";
import CountrySelect from "../../../../CountrySelect";
import { Button } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PeopleIcon from '@mui/icons-material/People';
import TabPanel from "../../../../TabPanel";
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import InputAdornment from '@mui/material/InputAdornment';
import InfoIcon from '@mui/icons-material/Info';

const AdressTab = ({
    name, setName,
    email, setEmail,
    website, setWebsite,
    phoneNumber, setPhoneNumber,
    address_one, setAddressOne,
    address_two, setAddressTwo,
    locality, setLocality,
    zip_code, setZipCode,
    country, setCountry,
    currency, setCurrency,
    price_per_week, setPricePerWeek,
    price_extra_per_day, setPriceExtraPerDay,
    um_price, setUmPrice,
    include_kids, setIncludeKids,
    transfer_price, setTransferPrice,
    admin, bankAccounts,
    bankAccount, setBankAccount,
    abbreviation, setAbbreviation,
    trainingProgramPrice1, setTrainingProgramPrice1,
    trainingProgramPrice2, setTrainingProgramPrice2,
    trainingProgramPrice3, setTrainingProgramPrice3,
    trainingProgramPrice4, setTrainingProgramPrice4,
}) => {


    console.log(bankAccount)

    const handleSelectBankAccount = (bankAccountID) => {
        setBankAccount(bankAccountID)
    }

    const getCurrencyAsString = () => {
        switch (currency) {
            case 1:
                return "€";
            case 2:
                return "£"
            case 3:
                return "$"
        }
    }

    return (
        <Grid container>
            <Grid item xs={5}>
                <label htmlFor="name">Name</label>
                <Input type="text" size="small" className="form-control" name="name" value={name} onChange={(e) => setName(e.target.value)} readOnly={!admin} />
            </Grid>

            <Grid item xs={1}>
                <label htmlFor="name">Ab.</label>
                <Input type="text" size="small" className="form-control" name="name" value={abbreviation} onChange={(e) => setAbbreviation(e.target.value)} readOnly={!admin} />
            </Grid>

            <Grid item xs={6}>
                <label htmlFor="email">Email address</label>
                <Input type="text" className="form-control" size="small" name="email" value={email} onChange={(e) => setEmail(e.target.value)} readOnly={!admin} />
            </Grid>

            <Grid item xs={6}>
                <label htmlFor="email">Website</label>
                <Input type="text" className="form-control" size="small" name="website" value={website} onChange={(e) => setWebsite(e.target.value)} readOnly={!admin} />
            </Grid>

            <Grid item xs={4}>
                <label htmlFor="phone">Phone number</label>
                <Input type="tel" className="form-control" size="small" name="phone" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} readOnly={!admin} />
            </Grid>


            <Grid item xs={2}>
                <label>Include kids</label><br></br>
                <FormControlLabel control={<Switch checked={include_kids} onChange={(e) => setIncludeKids(e.target.checked)} disabled={!admin} />} />
            </Grid>


            <Grid item xs={12} />

            <Grid item xs={2}>
                <label htmlFor="address">Address</label>
                <Input type="text" className="form-control" name="address" size="small" value={address_one} onChange={(e) => setAddressOne(e.target.value)} readOnly={!admin} />
            </Grid>

            <Grid item xs={2}>
                <label htmlFor="address2">Address comp.</label>
                <Input type="text" className="form-control" name="adress2" size="small" value={address_two} onChange={(e) => setAddressTwo(e.target.value)} readOnly={!admin}
                />
            </Grid>

            <Grid item xs={3}>
                <label htmlFor="email">Locality</label>
                <Input type="text" className="form-control" name="locality" size="small" value={locality} onChange={(e) => setLocality(e.target.value)} readOnly={!admin} />
            </Grid>

            <Grid item xs={2}>
                <label htmlFor="email">Zipcode</label>
                <Input type="text" className="form-control" name="locality" size="small" value={zip_code} onChange={(e) => setZipCode(e.target.value)} readOnly={!admin} />
            </Grid>

            <Grid item xs={3}>
                <label htmlFor="country">Country</label>
                <CountrySelect setValue={setCountry} selectedCode={country} readOnly={!admin} />
            </Grid>


            <Grid item xs={12} />

            {admin &&
                <>

                    <Grid item xs={3}>
                        <label htmlFor="currency">Bank Account</label>
                        <Select size="small" style={{ minWidth: '100%' }} value={bankAccount} onChange={(e) => handleSelectBankAccount(e.target.value)}>
                            <MenuItem value={null}>{''}</MenuItem>
                            {bankAccounts.map((bankAccount) => (
                                <MenuItem value={bankAccount.id}>{bankAccount.name}</MenuItem>
                            ))}
                        </Select>
                    </Grid>

                    <Grid item xs={1}>
                        <label htmlFor="currency">Currency</label>
                        <Select size="small" style={{ minWidth: '100%' }} value={currency || 0} onChange={(e) => setCurrency(e.target.value)}>
                            <MenuItem value={1}>€</MenuItem>
                            <MenuItem value={2}>£</MenuItem>
                            <MenuItem value={3}>$</MenuItem>
                        </Select>
                    </Grid>

                    <Grid item xs={2}>
                        <label>Price per week</label>
                        <TextField
                            disabled={trainingProgramPrice1 > 0 || trainingProgramPrice2 > 0 || trainingProgramPrice3 > 0 || trainingProgramPrice4 > 0}
                            size="small" value={price_per_week} onChange={(e) => setPricePerWeek(e.target.value)}
                            InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
                    </Grid>

                    <Grid item xs={2}>
                        <label>Price extra per day</label>
                        <TextField size="small" value={price_extra_per_day} onChange={(e) => setPriceExtraPerDay(e.target.value)}
                            InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
                    </Grid>

                    <Grid item xs={2}>
                        <label>UM Price</label>
                        <TextField size="small" value={um_price} onChange={(e) => setUmPrice(e.target.value)}
                            InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
                    </Grid>


                    <Grid item xs={2}>
                        <label>Transfer Price</label>
                        <TextField size="small" value={transfer_price} onChange={(e) => setTransferPrice(e.target.value)}
                            InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
                    </Grid>

                    <Grid item xs={3}>
                        <label>Little Explorers (7-11)</label>
                        <TextField size="small" value={trainingProgramPrice1} onChange={(e) => setTrainingProgramPrice1(e.target.value)}
                            InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
                    </Grid>
                    <Grid item xs={3}>
                        <label>New Adventurers (10-14)</label>
                        <TextField size="small" value={trainingProgramPrice2} onChange={(e) => setTrainingProgramPrice2(e.target.value)}
                            InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
                    </Grid>
                    <Grid item xs={3}>
                        <label>Rising Learners (12-15)</label>
                        <TextField size="small" value={trainingProgramPrice3} onChange={(e) => setTrainingProgramPrice3(e.target.value)}
                            InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
                    </Grid>
                    <Grid item xs={3}>
                        <label>Future Leaders (15-18)</label>
                        <TextField size="small" value={trainingProgramPrice4} onChange={(e) => setTrainingProgramPrice4(e.target.value)}
                            InputProps={{ endAdornment: <InputAdornment position="end">{getCurrencyAsString()}</InputAdornment> }} />
                    </Grid>

                </>
            }
            <Grid />
        </Grid>
    )
}

export default AdressTab;